import "./styles.css";
import React from "react";
import Modal from '../component/action-modal-edit-sequence';

function DoAnalyzerForm(props) {
  const PARAM = props.workorder;
  const PARAM_EQ = props.attachequipment;

  const PARAM_CALLBACK = (e) => props.callback(e);
  // console.log(PARAM);
  // console.log(PARAM_EQ);

  function getSequence(std, result_type) {
    let result = [];
    let found_sequence = PARAM.sequence.filter((sequence) => ((sequence.standardid === std.standardid) && (sequence.result === result_type)));
    // console.log(std, found_sequence);
    if (found_sequence.length > 0) {
      result = found_sequence;
    }
    return result;
  }

  function getPercentOfSpan(sequence, io_type) {
    let result = "";
    let reading = ((io_type === "input") ? (sequence.indicator !== null ? sequence.indicator : 0) : (sequence.transmission !== null ? sequence.transmission : 0));
    let std_output = ((io_type === "input") ? (sequence.input !== null ? sequence.input : 0) : (sequence.output !== null ? sequence.output : 0));
    result = ((reading.toFixed(3) - std_output.toFixed(3)) / 16 * 100).toFixed(3);
    return result;
  }

  function getStatusColor(sequence, io_type, mod) {
    let reading = ((io_type === "input") ? (sequence.indicator !== null ? sequence.indicator : 0) : (sequence.transmission !== null ? sequence.transmission : 0));
    let std_output = ((io_type === "input") ? (sequence.input !== null ? sequence.input : 0) : (sequence.output !== null ? sequence.output : 0));

    let tolerance = ((mod === "error") ? PARAM_EQ.mt_tolerance : PARAM_EQ.mt_errorspan);

    let error = ((mod === "error") ? (reading.toFixed(3) - std_output.toFixed(3)) : ((reading.toFixed(3) - std_output.toFixed(3)) / 16 * 100).toFixed(3));

    if (error > tolerance) {
      return "red"
    } else {
      return "green"
    }
  }

  function getUnit(io_type) {
    let result = "";
    if (PARAM.form && PARAM.form.length > 0) {
      switch (io_type) {
        case "input":
          result = "(" + PARAM.form[0].input_unit + ")";
          break;
        case "output":
          result = "(" + PARAM.form[0].output_unit + ")";
          break;

        default:
          break;
      }
    }
    return result;
  }

  return (
    <div className="content">
      <div className="content-page">
        <div className="head-content-page" style={{ margin: 0, height: 60 }}>
          DO Analyzer
        </div>
        <div className="head-content-page-sub" style={{ margin: 0 }}>
          Calibration Result : As Found
        </div>
        <table className={"table-form " + PARAM.formcode}>
          <tbody>
            <tr>
              <th colSpan={3}>Standard</th>
              <th rowSpan={2}>Compensate Temp Reading</th>
              <th colSpan={3}>Indicator</th>
              <th colSpan={3}>Transmission output</th>
              <th rowSpan={2}>Action</th>
            </tr>
            <tr>
              <th>Std.Name</th>
              <th>Input {getUnit("input")}</th>
              <th>Output {getUnit("output")}</th>
              <th>Reading {getUnit("input")}</th>
              <th>Error {getUnit("input")}</th>
              <th>Error (% of Span)</th>
              <th>Reading {getUnit("output")}</th>
              <th>Error {getUnit("output")}</th>
              <th>Error (% of Span)</th>
            </tr>
            {PARAM.form[0].standards.map((standard, i) => {

              let row_sequence = getSequence(standard, "ASFOUND");

              return (row_sequence.map((sequence, j) =>
                <tr key={j}>
                  <td>{j === 0 ? standard.standardname : null}</td>
                  <td>{sequence.input}</td>
                  <td>{sequence.output}</td>
                  <td>{sequence.degree_c}</td>
                  <td>{sequence.indicator}</td>
                  <td style={{ color: getStatusColor(sequence, "input", "error") }}>
                    {(sequence.indicator - sequence.input).toFixed(1)}
                  </td>
                  <td style={{ color: getStatusColor(sequence, "input", "error") }}>
                    {getPercentOfSpan(sequence, "input")}
                  </td>
                  <td>{sequence.transmission}</td>
                  <td style={{ color: getStatusColor(sequence, "output", "error") }}>
                    {(sequence.transmission - sequence.output).toFixed(1)}
                  </td>
                  <td style={{ color: getStatusColor(sequence, "output", "error") }}>
                    {getPercentOfSpan(sequence, "output")}
                  </td>
                  <td>
                    <Modal
                      reload={PARAM_CALLBACK}
                      data={sequence}
                      titleButton={'Edit'}
                      form={[
                        { displayName: "Input (ppm)", attName: "input", type: "text" },
                        { displayName: "Output (mA)", attName: "output", type: "text" },
                        { displayName: "Compensate Temp Reading", attName: "degree_c", type: "text" },
                        { displayName: "Indicator (ppm)", attName: "indicator", type: "text" },
                        { displayName: "Transmission (mA)", attName: "transmission", type: "text" }
                      ]}
                    ></Modal>
                  </td>
                </tr>)
              );
            })}
          </tbody>
        </table>

        <div className="head-content-page-sub" style={{ margin: 0 }}>
          Calibration Result : As Left
        </div>
        <table className={"table-form " + PARAM.formcode}>
          <tbody>
            <tr>
              <th colSpan={3}>Standard</th>
              <th rowSpan={2}>Compensate Temp Reading</th>
              <th colSpan={3}>Indicator</th>
              <th colSpan={3}>Transmission output</th>
              <th rowSpan={2}>Action</th>
            </tr>
            <tr>
              <th>Std.Name</th>
              <th>Input {getUnit("input")}</th>
              <th>Output {getUnit("output")}</th>
              <th>Reading {getUnit("input")}</th>
              <th>Error {getUnit("input")}</th>
              <th>Error (% of Span)</th>
              <th>Reading {getUnit("output")}</th>
              <th>Error {getUnit("output")}</th>
              <th>Error (% of Span)</th>
            </tr>
            {PARAM.form[0].standards.map((standard, i) => {

              let row_sequence = getSequence(standard, "ASLEFT");
              // console.log("row_sequence --> ", row_sequence);
              return (row_sequence.map((sequence, j) =>
                <tr key={j}>
                  <td>{j === 0 ? standard.standardname : null}</td>
                  <td>{sequence.input}</td>
                  <td>{sequence.output}</td>
                  <td>{sequence.degree_c}</td>
                  <td>{sequence.indicator}</td>
                  <td style={{ color: getStatusColor(sequence, "input", "error") }}>
                    {(sequence.indicator - sequence.input).toFixed(1)}
                  </td>
                  <td style={{ color: getStatusColor(sequence, "input", "error") }}>
                    {getPercentOfSpan(sequence, "input")}
                  </td>
                  <td>{sequence.transmission}</td>
                  <td style={{ color: getStatusColor(sequence, "output", "error") }}>
                    {(sequence.transmission - sequence.output).toFixed(1)}
                  </td>
                  <td style={{ color: getStatusColor(sequence, "output", "error") }}>
                    {getPercentOfSpan(sequence, "output")}
                  </td>
                  <td>
                    <Modal
                      reload={PARAM_CALLBACK}
                      data={sequence}
                      titleButton={'Edit'}
                      form={[
                        { displayName: "Input (ppm)", attName: "input", type: "text" },
                        { displayName: "Output (mA)", attName: "output", type: "text" },
                        { displayName: "Compensate Temp Reading", attName: "degree_c", type: "text" },
                        { displayName: "Indicator (ppm)", attName: "indicator", type: "text" },
                        { displayName: "Transmission (mA)", attName: "transmission", type: "text" }
                      ]}
                    ></Modal>
                  </td>
                </tr>)
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DoAnalyzerForm;
